"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkIfFriendExists = exports.checkIfAnyUserLoggedIn = exports.saveNewFriend = exports.createAddMeToYourFriendsButton = exports.addMeToYourFriendsDiv = void 0;
var lit_html_1 = require("lit-html");
var style_map_js_1 = require("lit-html/directives/style-map.js");
var solid_logic_1 = require("solid-logic");
var solid_ui_1 = require("solid-ui");
var addMeToYourFriendsHelper_1 = require("./addMeToYourFriendsHelper");
var baseStyles_1 = require("./baseStyles");
var texts_1 = require("./texts");
var buttonContainer = document.createElement("div");
//panel local style
var styles = {
    button: (0, style_map_js_1.styleMap)(__assign(__assign({}, (0, baseStyles_1.textCenter)()), (0, baseStyles_1.padding)())),
};
var addMeToYourFriendsDiv = function (subject, context) {
    buttonContainer = context.dom.createElement("div");
    var button = createAddMeToYourFriendsButton(subject, context);
    buttonContainer.appendChild(button);
    return (0, lit_html_1.html)(templateObject_1 || (templateObject_1 = __makeTemplateObject([" <div style=\"", "\">", "</div> "], [" <div style=\"", "\">", "</div> "])), styles.button, buttonContainer);
};
exports.addMeToYourFriendsDiv = addMeToYourFriendsDiv;
var createAddMeToYourFriendsButton = function (subject, context) {
    var button = solid_ui_1.widgets.button(context.dom, undefined, texts_1.logInAddMeToYourFriendsButtonText, setButtonHandler, //sets an onclick event listener
    {
        needsBorder: true,
    });
    function setButtonHandler(event) {
        event.preventDefault();
        saveNewFriend(subject, context)
            .then(function () {
            (0, addMeToYourFriendsHelper_1.clearPreviousMessage)(buttonContainer);
            (0, addMeToYourFriendsHelper_1.mention)(buttonContainer, texts_1.friendWasAddedSuccesMessage);
            refreshButton();
        })
            .catch(function (error) {
            (0, addMeToYourFriendsHelper_1.clearPreviousMessage)(buttonContainer);
            //else UI.widgets.complain(buttonContainer, message); //displays an error message at the top of the window
            (0, addMeToYourFriendsHelper_1.complain)(buttonContainer, context, error);
        });
    }
    button.refresh = refreshButton();
    function refreshButton() {
        var me = solid_logic_1.authn.currentUser();
        var store = context.session.store;
        if (checkIfAnyUserLoggedIn(me)) {
            checkIfFriendExists(store, me, subject).then(function (friendExists) {
                if (friendExists) {
                    //logged in and friend exists or friend was just added
                    button.innerHTML = texts_1.friendExistsAlreadyButtonText.toUpperCase();
                    button.setAttribute("class", "textButton-0-1-3"); //style of 'Primary' UI button with needsBorder=true
                }
                else {
                    //logged in and friend does not exist yet
                    button.innerHTML = texts_1.addMeToYourFriendsButtonText.toUpperCase();
                    button.setAttribute("class", "textButton-0-1-2"); //style of 'Primary' UI button with needsBorder=false
                }
            });
        }
        else {
            //not logged in
            button.innerHTML = texts_1.logInAddMeToYourFriendsButtonText.toUpperCase();
            button.setAttribute("class", "textButton-0-1-3"); //style of 'Primary' UI button with needsBorder=false
        }
    }
    return button;
};
exports.createAddMeToYourFriendsButton = createAddMeToYourFriendsButton;
function saveNewFriend(subject, context) {
    return __awaiter(this, void 0, void 0, function () {
        var me, store, updater, toBeInserted, error_1, errorMessage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    me = solid_logic_1.authn.currentUser();
                    store = context.session.store;
                    if (!checkIfAnyUserLoggedIn(me)) return [3 /*break*/, 9];
                    return [4 /*yield*/, checkIfFriendExists(store, me, subject)];
                case 1:
                    if (!!(_a.sent())) return [3 /*break*/, 7];
                    //if friend does not exist, we add her/him
                    return [4 /*yield*/, store.fetcher.load(me)];
                case 2:
                    //if friend does not exist, we add her/him
                    _a.sent();
                    updater = store.updater;
                    toBeInserted = [solid_ui_1.rdf.st(me, solid_ui_1.ns.foaf("knows"), subject, me.doc())];
                    _a.label = 3;
                case 3:
                    _a.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, updater.update([], toBeInserted)];
                case 4:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 5:
                    error_1 = _a.sent();
                    errorMessage = error_1;
                    if (errorMessage.toString().includes("Unauthenticated"))
                        errorMessage = texts_1.userNotLoggedInErrorMessage;
                    throw new Error(errorMessage);
                case 6: return [3 /*break*/, 8];
                case 7: throw new Error(texts_1.friendExistsMessage);
                case 8: return [3 /*break*/, 10];
                case 9: throw new Error(texts_1.userNotLoggedInErrorMessage);
                case 10: return [2 /*return*/];
            }
        });
    });
}
exports.saveNewFriend = saveNewFriend;
function checkIfAnyUserLoggedIn(me) {
    if (me)
        return true;
    else
        return false;
}
exports.checkIfAnyUserLoggedIn = checkIfAnyUserLoggedIn;
function checkIfFriendExists(store, me, subject) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, store.fetcher.load(me)];
                case 1:
                    _a.sent();
                    if (store.whether(me, solid_ui_1.ns.foaf("knows"), subject, me.doc()) === 0)
                        return [2 /*return*/, false];
                    else
                        return [2 /*return*/, true];
                    return [2 /*return*/];
            }
        });
    });
}
exports.checkIfFriendExists = checkIfFriendExists;
var templateObject_1;
//# sourceMappingURL=addMeToYourFriends.js.map